import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { UpdateUserSettingsDto } from "../../../model/user/settings/dto/UpdateUserSettingsDto";
import { Spacing } from "../../../theme/Spacing";
import { Button } from "../../../components/Button";
import { AtiraToast } from "../../../utils/AtiraToast";
import { TimezonePicker } from "../../../components/TimezonePicker";
import { SettingsWrapper } from "../components/SettingsWrapper";
import { CurrencyPicker } from "../../../components/CurrencyPicker";

const SaveButton = styled(Button)`
  margin: 0;
  width: fit-content;
  margin-top: ${Spacing.m};
`;

type SettingsGeneralProps = {
  onSave: VoidFunction;
};

export const SettingsGeneral: React.FC<SettingsGeneralProps> = ({ onSave }) => {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const { control } = useFormContext<UpdateUserSettingsDto>();

  const localeOnSave = async () => {
    try {
      setLoading(true);
      await onSave();
    } catch (e: any) {
      AtiraToast.apiError(e);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SettingsWrapper>
      <Controller
        name="timezone"
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TimezonePicker
            value={value}
            onChange={(e: any) => onChange(e?.value)}
            info={t("settings.general.timezone.info")}
            error={error}
          />
        )}
      />

      <Controller
        name="currency"
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <CurrencyPicker
            value={value}
            onChange={(e: any) => onChange(e?.value)}
            info={t("settings.general.currency.info")}
            error={error}
          />
        )}
      />

      <SaveButton onClick={localeOnSave} loading={loading}>
        {t("common.save_changes")}
      </SaveButton>
    </SettingsWrapper>
  );
};
